module.exports = __webpack_public_path__ + "img/720.eafff961.svg";